var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeLinkSizemWeightoutlined = function SvgTypeLinkSizemWeightoutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M22.5 8.272A5.1 5.1 0 0 1 21 11.74L17.742 15a5.09 5.09 0 0 1-3.621 1.5h-.005A5.123 5.123 0 0 1 9 11.235a.75.75 0 1 1 1.5.042 3.62 3.62 0 0 0 6.177 2.663l3.258-3.258a3.622 3.622 0 0 0-5.122-5.122l-1.03 1.032a.75.75 0 0 1-1.061-1.06L13.753 4.5A5.124 5.124 0 0 1 22.5 8.272m-12.281 9.134-1.032 1.03A3.6 3.6 0 0 1 6.62 19.5a3.622 3.622 0 0 1-2.559-6.182l3.252-3.258a3.622 3.622 0 0 1 6.188 2.663.75.75 0 1 0 1.5.042A5.14 5.14 0 0 0 13.5 9a5.124 5.124 0 0 0-7.244 0L3 12.258a5.12 5.12 0 0 0 5.576 8.355 5.1 5.1 0 0 0 1.662-1.113l1.03-1.031a.75.75 0 0 0-1.05-1.063"
  })));
};
export default SvgTypeLinkSizemWeightoutlined;